import { Api } from "@/services/Api";

export default {
  activePlantDetail(plantId) {
    return Api().get(`/api/v2/active-plant/${plantId}`);
  }
};
